import React from "react";
import PresenceImmersion from "./PresenceImmersion";

export const EveningImmersion = () => <PresenceImmersion session="evening" />;

export default EveningImmersion;
